import React from "react";
import "./BasketNo.css";
// Basket
function BasketNo() {
  return (
    <div className="container_defenseNo">
      <div className="defenseNo">No content.</div>
    </div>
  );
}

export default BasketNo;
